import orders from '@/http/requests/orders';

export default {
    fetchAll({ commit }, data) {
        return new Promise((resolve, reject) => {
            orders.fetchAll(data.sortName, data.page, data.itemsPerPage, data.type, data.word, data.customerId)
            .then((response) => {
                const parsedData = response.data.data.getOrder;

                commit('SET_ORDERS', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        });
    },
    fetchAllPreOrders({ commit }, data) {
        return new Promise((resolve, reject) => {
            orders.fetchAllPreOrders(data.sortName, data.page, data.itemsPerPage, data.type, data.word, data.customerId)
            .then((response) => {
                const parsedData = response.data.data.getOrder;

                commit('SET_PRE_ORDERS', parsedData);
                resolve(response);
            })
            .catch((exception) => {
                reject(exception);
            });
        })
    },
    update({ commit }, data) {
        return new Promise((resolve, reject) => {
            orders.update(data)
            .then((response) => {
                const parsedData = response.data.data.updateOrder;

                commit('UPDATE_ORDERS', parsedData);
                resolve(parsedData);
            })
            .catch((exception) => {
                reject(exception);
            });
        })
    },
    updatePreOrders({ commit }, data) {
        return new Promise((resolve, reject) => {
            orders.update(data)
            .then((response) => {
                const parsedData = response.data.data.updateOrder;

                commit('UPDATE_PRE_ORDERS', parsedData);
                resolve(parsedData);
            })
            .catch((exception) => {
                reject(exception);
            });
        })
    }
}